import ScanTestTubeLog from "./ScanTestTubeLog.vue";
export default ScanTestTubeLog;
